var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { GoogleOAuthProvider, GoogleLogin, } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import LinkGenerator from "@nerdwallet/nw-auth-links";
// to-do move to env variable
const GOOGLE_IDENTITY_CLIENT_ID = "881857878405-fpit025a01be1aeditig97fo833v897j.apps.googleusercontent.com";
const GoogleButton = (_a) => {
    var { buttonWidth = "340", onSubmit } = _a, authParams = __rest(_a, ["buttonWidth", "onSubmit"]);
    const linkGenerator = new LinkGenerator();
    const handleSuccess = (token) => {
        if (token.credential) {
            if (onSubmit) {
                onSubmit();
            }
            const response = jwtDecode(token.credential);
            window.location.href = linkGenerator.googleAuth(Object.assign(Object.assign({}, authParams), { login_hint: response.email }));
        }
    };
    const defaultButtonProps = {
        size: "large",
        theme: "filled_blue",
        type: "standard",
        text: "continue_with",
        width: buttonWidth,
    };
    return (_jsx(GoogleOAuthProvider, Object.assign({ clientId: GOOGLE_IDENTITY_CLIENT_ID }, { children: _jsx(GoogleLogin, Object.assign({}, defaultButtonProps, { onSuccess: handleSuccess })) })));
};
export default GoogleButton;
//# sourceMappingURL=GoogleButton.js.map